'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which is best Maratha marriage bureau in Maharashtra?', answer: 'For Maratha Lagin Sarai, MarathiVadhuVarSuchak.com is the best Maratha marriage bureau in Maharashtra state. To Maratha Lagin Sarai login first signup free on this site. Check Maratha Lagin Sarai review here.' },
  { question: 'Which is best Maratha matrimonial site in Pune?', answer: 'For Maratha Lagin Sarai Kokanastha community, MarathiVadhuVarSuchak.com is the best trusted Maratha marriage bureau. For Maratha Lagin Sarai - 96 Kuli Deshastha Kokanastha Maratha Matrimony, you have to sign up for free.' },
  { question: 'Which is the best Maratha matrimony in Mumbai?', answer: 'For Maratha Vivah Maratha Matrimony Login, register for free on MarathiVadhuVarSuchak.com matrimony app. Best for Maratha Matrimony Latur and Marathi Matrimony Pune registration. Now, check Maratha Matrimony Reviews for free Maratha Marriage Login.' },
  { question: 'How to do sign up free on Maratha Marriage bureau?', answer: 'For Lok Maratha Vadhu Var Suchak free registration, visit MarathiVadhuVarSuchak.com matrimony portal. You can search maratha Brides and grooms here. For marathi Vadhu Var Suchak Login visit site now.' },
  { question: 'Which is the most trusted Maratha Marriage bureau at Vasai-Virar?', answer: "To search Adarshmaratha site, visit MarathiVadhuVarSuchak.com matrimony. This is the best Adarsh Maratha Vadhu Var Suchak in Vasai Virar for Adarsh Maratha bride's search. Here at Adarsh Maratha Vadhu Var Mandal a well know Adarsh Maratha Matrimony registration is free." },
  { question: 'Which is the trusted Maratha Marriage bureau at Paschim Maharashtra?', answer: "You have best option of Adarsh Maratha Vadhu Var Suchak Kendra Karad based profile search on MarathiVadhuVarSuchak.com. Here you can get Adarsh Maratha Karad based bride and groom's profile." },
  { question: 'Which is the best Maratha Lagna Sanstha in Pune?', answer: 'For Maratha lagna sanstha of grooms and brides, register free on MarathiVadhuVarSuchak.com. You can search lagna sanstha Maratha marriage Satara based (Lagna sanstha photos) profiles here.' },
  { question: 'Which is best Maratha Marriage bureau for Lagna karya?', answer: 'Best option like MarathiVadhuVarSuchak.com for Shri Maratha Vadhu Var Suchak Kendra in Mumbai.' },
];

export default function LokMarathaAdarshMarathaClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="96 कुळी मराठा वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="lok_maratha_adarsh_maratha"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
            96 Kuli Maratha Matrimony | Marathi Vadhu Var Suchak
            </h2>
            <p className="text-gray-700 leading-relaxed" style={{ fontSize: '1.11rem' }}>
            Find your perfect life partner within the prestigious 96 Kuli Maratha community on MarathiVadhuVarSuchak.com - Maharashtra's most trusted Marathi matrimony platform. Our dedicated 96 Kuli Maratha matrimonial page connects verified Marathi brides and grooms who proudly uphold the rich cultural values, traditions, and heritage of the 96 Kuli Maratha community. Whether you are searching for a 96 Kuli Maratha Vadhu or a 96 Kuli Maratha var, our curated profiles make your Marathi marriage journey meaningful and successful. We understand the importance of gotra, Kul, and family background in Maratha matrimony, ensuring every match respects your community roots. Register free today and explore hundreds of 96 Kuli Maratha marriage profiles from across Maharashtra and beyond - because your ideal Marathi life partner is just a click away. Find Verified 96 Kuli Maratha Brides & Grooms from Maharashtra, India and abroad.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
